import { createSelector } from 'reselect';
import ReceptaclePodPerformanceDetailsColumns from '../../containers/ReceptaclePodPerformanceDetailsColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.RECEPTACLE_POD_PERFORMANCE_404_DETAILS.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.RECEPTACLE_POD_PERFORMANCE_404_DETAILS.isLoading;

export const getData =
  ReportDefinitions.RECEPTACLE_POD_PERFORMANCE_404_DETAILS.getDataFunction();

export const getColumns =
  createSelector(getData, ReceptaclePodPerformanceDetailsColumns);
